import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LinkContext } from "../../LinkProvider";
import AnimatedCTA from "../AnimatedCTA";
import chevronRightCircle from "../../img/experience/chevron-right-circle.svg";

const MARKETS = [
  { num: "01", nameKey: "exp.markets.m1" },
  { num: "02", nameKey: "exp.markets.m2" },
  { num: "03", nameKey: "exp.markets.m3" },
  { num: "04", nameKey: "exp.markets.m4" },
  { num: "05", nameKey: "exp.markets.m5" },
];

function Markets() {
  const { t } = useTranslation();
  const { link } = useContext(LinkContext);

  return (
    <section className="mt">
      <div className="glcontainer flex flex-col xl:flex-row xl:items-start gap-[40px] xl:gap-[103px]">
        {/* Left */}
        <div className="xl:w-[517px] xl:shrink-0 flex flex-col justify-between xl:h-[540px] gap-[40px] xl:gap-0">
          <div className="flex flex-col gap-[40px]">
            <h2 className="font-['Montserrat'] font-black text-[24px] xl:text-[46px] text-[#0a0a0a] tracking-[-0.92px] uppercase leading-none">
              {t("exp.markets.title")}
            </h2>
            <p className="font-['Inter'] font-normal text-[14px] xl:text-[18px] text-[#717171] leading-[1.4]">
              {t("exp.markets.desc")}
            </p>
          </div>
          <div className="flex flex-col gap-[4px] xl:gap-[0px]">
            <p className="font-['Montserrat'] font-black text-[14px] xl:text-[20px] text-[#ccc] tracking-[-0.92px] uppercase leading-none">
              {t("exp.markets.quote1")}
            </p>
            <p className="font-['Montserrat'] font-black text-[20px] xl:text-[32px] text-[#ccc] tracking-[-0.92px] uppercase leading-none">
              {t("exp.markets.quote2")}
            </p>
          </div>
          <AnimatedCTA href={link} mobile>{t("btn.start-trading")}</AnimatedCTA>
        </div>

        {/* Right: numbered list */}
        <div className="flex flex-col flex-1">
          {MARKETS.map((market, i) => (
            <div key={i} className={`flex items-center justify-between py-[18px] xl:py-[26px] ${i < MARKETS.length - 1 ? "border-b border-[rgba(0,0,0,0.1)]" : ""}`}>
              <div className="flex items-center gap-[20px] xl:gap-[30px]">
                <span className="font-['Montserrat'] font-semibold text-[14px] xl:text-[20px] text-[#bababa] w-[24px] xl:w-[28px] shrink-0">
                  {market.num}
                </span>
                <span className="font-['Montserrat'] font-bold text-[20px] xl:text-[36px] text-[#020202] leading-normal">
                  {t(market.nameKey)}
                </span>
              </div>
              <div className="shrink-0 size-[30px] xl:size-[56px]">
                <img src={chevronRightCircle} alt="" aria-hidden className="w-full h-full" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Markets;
